import { getOrderItems } from "../../utils/orderItems";

export default function OrderItems({ order, onSwapMeal, onSwapDrink }: {
  order: any;
  onSwapMeal: (index: number) => void;
  onSwapDrink: (index: number) => void;
}) {
  const items = getOrderItems(order);
  return <div className="space-y-2 min-w-[220px]">
    {items.map(item => <div key={item.key} className={`rounded-md border border-slate-200 border-l-[3px] bg-white px-2.5 py-2 ${item.kind === "addon" ? "border-l-amber-500" : item.kind === "drink" ? "border-l-emerald-500" : item.detail === "Light" ? "border-l-sky-600" : "border-l-violet-600"}`}>
      <div className="text-[13px] leading-5 font-semibold text-slate-900">{item.quantity} × {item.name}</div>
      <div className="mt-1 flex items-center gap-1.5 flex-wrap">
        {item.detail && <span className={`inline-flex items-center px-2 py-0.5 text-[11px] leading-4 font-bold rounded border ${item.kind === "addon" ? "bg-amber-100 text-amber-900 border-amber-300" : item.detail === "Classic" ? "bg-violet-700 text-white border-violet-700" : item.detail === "Light" ? "bg-sky-700 text-white border-sky-700" : "bg-emerald-50 text-emerald-900 border-emerald-300"}`}>{item.detail}</span>}
        {item.swapped && <span className="rounded bg-green-50 px-1.5 py-0.5 text-[10px] leading-4 font-medium text-green-800">Swapped</span>}
      </div>
      {order.status === "pending" && item.kind !== "addon" && <div className="flex flex-wrap gap-1 mt-1">
        {item.indices.map(index => <button key={index} type="button"
          aria-label={`Swap ${item.kind} ${index + 1}: ${item.name}`}
          onClick={() => item.kind === "meal" ? onSwapMeal(index) : onSwapDrink(index)}
          className="px-2 py-0.5 text-[11px] leading-4 font-medium rounded border border-orange-300 bg-orange-50 text-orange-800 hover:bg-orange-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-500">
          {item.kind === "drink" ? "Swap Drink" : "Swap"} #{index + 1}
        </button>)}
      </div>}
    </div>)}
    {!items.length && <span className="text-xs text-gray-500">No items</span>}
    {order.status === "pending" && !items.some(item => item.kind === "drink") && <button type="button"
      onClick={() => onSwapDrink(0)} className="w-full px-2 py-1 text-[11px] leading-4 font-medium rounded-md border border-dashed border-slate-400 bg-white text-slate-700 hover:border-orange-400 hover:bg-orange-50">+ Add Drink</button>}
  </div>;
}
